<template>
  <div>
    <div class="land-home-carousel">
      <div style="width:1200px; margin:0 auto">
        <div class="solution-banner-title">科技有温度 &nbsp;造价更美好</div>
          <div class="solution-banner-text">数字新成本解决方案以企业成本数据积累与应用的闭环打通为核心，<br>赋能企业实现数据资产化、作业高效化、决策智能化，让每一个工程项目成功。</div>
      </div>
    </div>
  </div>
</template>

<script>
// const bannerUrl = require('../../../../../../assets/images/land-page/land-home/construction-banner.png')
export default {
  name: 'landApplicationBanner',
  data () {
    return {
      // bannerUrl: bannerUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.land-home-carousel {
  // width: 1920px;
  width: 100%;
  height: 367px;
  margin: auto;
  background-color: #4499ff;
  background: url("../../../../../../assets/images/land-page/land-home/case-banner.jpg")
    no-repeat;
  background-size: cover;
  display: flex;
  // img {
  //   // height:367px ;
  //   display: block;
  //   width: 100%;
  //   height: 100%;
  // }

  .solution-banner-title {
    margin-top: 123px;
    // margin-left: 362px;
    // width: 270px;
    font-size: 28px;
    font-weight: normal;
    color: #ffffff;
    line-height: 32px;
    letter-spacing: 2px;
  }
  .solution-banner-text {
    margin-top: 14px;
    // margin-left: 362px;
    width: 590px;
    font-size: 15px;
    font-weight: normal;
    color: #ffffff;
    line-height: 24px;
  }
}
</style>
